import { ConfigProvider } from "@app/providers/config"
import { LocationProvider } from "@app/providers/location"
import { Meta } from "@app/components/Meta"

export const Head = ({ data, location, children }: any) => (
  <LocationProvider>
    <ConfigProvider>
      <Meta data={data} location={location}>
        {children}
      </Meta>
    </ConfigProvider>
  </LocationProvider>
)
